var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIzqIcoFundacionBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2808_169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.0575 7.05754L5.835 11.835L6.8925 10.77L2.8725 6.75004H15V5.25004H2.8725L6.8925 1.23004L5.835 0.165039L1.0575 4.94254L0 6.00004L1.0575 7.05754Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2808_169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIzqIcoFundacionBi);
export default __webpack_public_path__ + "static/media/izq-ico-fundacion-bi.9316856ebedbffecf27c1626a1c51726.svg";
export { ForwardRef as ReactComponent };